<template>
	<div class="page page-video">
		<div ref="overlay" class="page-overlay"></div>
		<div class="lines-wrapper">
			<div ref="lines1" class="lines1"></div>
			<div ref="lines2" class="lines2"></div>
		</div>
		<div class="page-content">
			<div class="title-wrapper">
				<transition name="slideLeft">
					<h2 class="title" v-show="canAnimate2">Смотри видеоотчеты</h2>
				</transition>

			</div>
				<ul v-if="!Helpers.isTouch()" class="video-list">
					<li class="video-item" v-for="(item, key) in weeks" :class="{disabled: item.closed}">
						<div class="item-content">
							<div class="video-preview"
								 :style="`background-image: url(${item.closed ? '/static/img/video/lock.png' : item.preview})`">
								<a href="#" @click.prevent="showVideo(item.video)" v-if="!item.closed" class="play">
									<play></play>
								</a>
							</div>
							<div v-if="!item.closed" class="player" :style="`background-image: url(${item.player})`"></div>
							<div v-if="!item.closed" class="footballer"
								 :style="`background-image: url(${item.footballer})`"></div>
						</div>
						<div class="item-text">
							<h6 class="text">{{ key + 1 }} неделя</h6>
						</div>
					</li>
				</ul>

			<swiper v-else class="video-list" :options="swiperOption" ref="mySwiper">
				<div class="swiper-button-prev" slot="button-prev"><arrow></arrow></div>
				<div class="swiper-button-next" slot="button-next"><arrow></arrow></div>
				<swiper-slide v-for="(item, key) in weeks" :key="key"
							  :class="{disabled: item.closed}">
					<div class="video-item">
						<div class="item-content">`
							<div class="video-preview"
								 :style="`background-image: url(${item.closed ? '/static/img/video/lock.png' : item.preview})`">
								<a href="#" @click.prevent="showVideo(item.video)" v-if="!item.closed" class="play">
									<play></play>
								</a>
							</div>
							<div v-if="!item.closed" class="player" :style="`background-image: url(${item.player})`"></div>
							<div v-if="!item.closed" class="footballer"
								 :style="`background-image: url(${item.footballer})`"></div>
						</div>
						<div class="item-text">
							<h6 class="text">{{ key + 1 }} неделя</h6>
						</div>
					</div>
				</swiper-slide>
			</swiper>

		</div>
	</div>
</template>

<script>
	import play from '@/assets/svg/play-arrow.svg';
	import arrow from '@/assets/svg/slider-arrow.svg';
	import Helpers from '@/tools/Helpers'
	import {TweenMax} from 'gsap'

	const weeks = [
		{
			closed: false,
			player: null,
			footballer: null,
			video: 'hvrklaZ-09A',
			preview: '/static/img/video/prev.jpg',
		},
		{
			closed: false,
			video: 'SVrKI0dTN9o',
			preview: '/static/img/video/prev2.jpg',
			player: null,
			footballer: null
		},
		{
			closed: false,
			video: '-2Dra9_Opuk',
			preview: '/static/img/video/prev3.jpg',
			player: null,
			footballer: null
		},
		{
			closed: false,
			video: 'CbLAOIkvb_8',
			preview: '/static/img/video/prev4.jpg',
			player: null,
			footballer: null
		},
		{
			closed: false,
			video: 'c2-UuEVZPSQ',
			preview: '/static/img/video/prev5.jpg',
			player: null,
			footballer: null
		}
	];
	export default {
		name: 'Video',
		props: ['canAnimate2'],
		components: {
			play,
			arrow,
			Helpers
		},
		data() {
			return {
				swiperOption: {
					slidesPerView: 'auto',
					prevButton: '.swiper-button-prev',
					nextButton: '.swiper-button-next',
                    centeredSlides: true,
					loop: true,
					onInit: () => {
                        setTimeout(()=> {
                            let resizeEvent = window.document.createEvent('UIEvents');
                            resizeEvent .initUIEvent('resize', true, false, window, 0);
                            window.dispatchEvent(resizeEvent);
                        },0);
					}
				},
				weeks,
				Helpers
			}
		},
		methods: {
			showVideo(videoId) {
				this.$store.commit('SET_POPUP', {
					name: 'Video',
					videoId: videoId
				});
			}
		},
		computed: {
			showPage(){
				return this.$route.name === 'Video'
			}
		},
		mounted(){
//			setTimeout(()=> {
//				this.$refs['mySwiper'].init();
//			},100);
		}
	}
</script>

<style lang="scss" scoped>
	.fadeIn-enter-active,
	.fadeIn-leave-active {
		opacity: 1;
		transition: opacity 1.5s;
	}

	.fadeIn-enter {
		opacity: 0;
	}

	.fadeIn-leave-to {
		opacity: 0;
	}


	.slideLeft-enter-active,
	.slideLeft-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0,0,0);
	}

	.slideLeft-enter {
		opacity: 0;
		transform: translate3d(-100%,0,0);
	}

	.slideLeft-leave-to {
		opacity: 0;
		transform: translate3d(-100%,0,0);
	}

	.slideRight-enter-active,
	.slideRight-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0,0,0);
	}

	.slideRight-enter {
		opacity: 0;
		transform: translate3d(100%,0,0);
	}

	.slideRight-leave-to {
		opacity: 0;
		transform: translate3d(100%,0,0);
	}

	.slideDown-enter-active,
	.slideDown-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0,0,0);
	}

	.slideDown-enter {
		opacity: 0;
		transform: translate3d(0,100%,0);
	}

	.slideDown-leave-to {
		opacity: 0;
		transform: translate3d(0,100%,0);
	}
</style>


// WEBPACK FOOTER //
// Video.vue?5f67c40a